import { IonButton, IonContent, IonImg, IonPage, IonTitle } from '@ionic/react';
import { useAtom, useSetAtom } from 'jotai';
import { useHistory } from 'react-router';
import madper from '../assets/images/madper.png';
import { fallbackErrorCountAtom, usersAtom } from '../utils/Global';

const FallbackComponent: React.FC = () => {
    const [fallbackErrorCount, setFallbackErrorCountAtom] = useAtom(fallbackErrorCountAtom);
    const setUser = useSetAtom(usersAtom);
    const history = useHistory();

    const onClick = () => {
        let nextFallbackErrorCount = fallbackErrorCount + 1;
        if (nextFallbackErrorCount === 2) {
            history.go(0);
        } else if (nextFallbackErrorCount > 2) {
            setUser({ mainUser: null });
            nextFallbackErrorCount = 0;
            window.location.reload();
        }
        setFallbackErrorCountAtom(nextFallbackErrorCount);
    };

    return (
        <IonPage>
            <IonContent fullscreen={true}>
                <div className="grid h-screen place-items-center">
                    <div>
                        <IonImg className="object-center w-40 mx-auto" src={madper} alt="Madper Logo" />
                        <IonTitle className="text-center">Une erreur est survenue</IonTitle>
                    </div>

                    <IonButton shape="round" onClick={onClick} expand="block" className="btn">
                        <button>{fallbackErrorCount < 2 ? 'Recharger la page' : 'Se déconnecter'}</button>
                    </IonButton>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default FallbackComponent;
